// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Env from "./Env.res.js";
import * as React from "react";
import * as PosthogJs from "posthog-js";
import * as Stdlib_JsExn from "@rescript/runtime/lib/es6/Stdlib_JsExn.js";
import * as React$1 from "@sentry/react";
import * as FatalErrorPage from "../app/Error/FatalErrorPage.res.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

function reportErrorMessage(prim) {
  React$1.captureMessage(prim);
}

function reportException(prim) {
  React$1.captureException(prim);
}

let contextIsOk = Env.context() === "production" || Env.context() === "staging";

function updateUserFields(userId, userName, shopId, shopName, deviceId, param) {
  if (contextIsOk) {
    React$1.setUser({
      userId: userId,
      username: userName,
      shopId: shopId,
      shopName: Primitive_option.some(shopName),
      deviceId: Primitive_option.some(deviceId)
    });
    return;
  }
}

function updateSessionUrl(session) {
  if (!contextIsOk) {
    return;
  }
  try {
    React$1.configureScope(scope => scope.setExtra("sessionURL", session));
    return;
  } catch (exn) {
    return;
  }
}

function BugTracker$Boundary(props) {
  let children = props.children;
  if (!contextIsOk) {
    return children;
  }
  let fallback = error => {
    let exn = Stdlib_JsExn.fromException(error);
    if (exn !== undefined) {
      PosthogJs.default.captureException(Primitive_option.valFromOption(exn));
    }
    return JsxRuntime.jsx(FatalErrorPage.make, {});
  };
  return JsxRuntime.jsx(React$1.ErrorBoundary, {
    children: children,
    fallback: fallback
  });
}

let make = React.memo(BugTracker$Boundary);

let Boundary = {
  make: make
};

export {
  reportErrorMessage,
  reportException,
  updateUserFields,
  updateSessionUrl,
  Boundary,
}
/* contextIsOk Not a pure module */
